import * as React from 'react';
import { HTMLAttributes } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import './styles.scss';

export interface ISimpleImageProps {
  url: string;
  aspectRatio: number;
  alt: string;
  style?: HTMLAttributes<HTMLDivElement>['style'];
  className?: string;
}

const SimpleImage: React.FunctionComponent<ISimpleImageProps> = (props) => {
  return (
    <div
      className={classNames('simple-image', props.className)}
      style={{
        aspectRatio: props.aspectRatio,
        ...props.style,
      }}
    >
      <Image
        src={props.url}
        alt={props.alt}
        fill={true}
        sizes="100vw"
      />
    </div>
  );
};

SimpleImage.displayName = 'SimpleImage';

export default SimpleImage;
